import { Link } from "@inertiajs/react";
import type { ColumnDef } from "@tanstack/react-table";
import { Eye } from "lucide-react";

import { Button } from "@/components/ui/button";
import { productPath } from "@/routes";
import type { Product } from "@/types";

export const columns: ColumnDef<Product>[] = [
  {
    accessorKey: "id",
    header: "ID",
    enableSorting: false,
  },
  {
    accessorKey: "internal_code",
    header: "Código Interno",
    enableSorting: false,
    cell: ({ row }) => {
      const internalCode = row.original.internal_code;
      return internalCode ? (
        <span className="text-muted-foreground">{internalCode}</span>
      ) : (
        <span className="text-muted-foreground">-</span>
      );
    },
  },
  {
    accessorKey: "normalized_name",
    header: "Nombre",
    enableSorting: false,
  },
  {
    accessorKey: "category_name",
    id: "category_name",
    header: "Categoría",
    enableSorting: false,
    cell: ({ row }) => {
      const category = row.original.category;
      return category ? (
        category.name
      ) : (
        <span className="text-muted-foreground">-</span>
      );
    },
  },
  {
    accessorKey: "subcategory_name",
    id: "subcategory_name",
    header: "Subcategoría",
    enableSorting: false,
    cell: ({ row }) => {
      const subcategory = row.original.subcategory;
      return subcategory ? (
        subcategory.name
      ) : (
        <span className="text-muted-foreground">-</span>
      );
    },
  },
  {
    id: "actions",
    header: "Acciones",
    cell: ({ row }) => {
      const product = row.original;

      return (
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="sm" asChild>
            <Link href={productPath(product)}>
              <Eye className="h-4 w-4" />
              Ver
            </Link>
          </Button>
        </div>
      );
    },
  },
];
